module.exports = {
    consultaAutenticidade: 'Consulta de autenticidade de %1',
    documentoNaoEncontrado: 'Documento não encontrado com os dados informados.',
    hash: 'Hash',
    identificador: 'Identificador',
    tamanhoCodigo: 'O código deve ter 44 caracteres',
    tamanhoCodigo24Caracteres: 'O código deve ter 24 caracteres',
    verificar: 'Verificar'
};